/**
 * File expand-content.js.
 */
(function () {
    document.querySelectorAll('.post-sidebar li > span').forEach((items) => {
        items.addEventListener('click', (e) => {
            document.querySelectorAll('.post-sidebar li.user-expanded').forEach((item) => {
                item.classList.remove('user-expanded');
            });
            e.currentTarget.parentElement.classList.add('user-expanded');
        });
    });

    document.querySelectorAll('.single-card .read-more-btn').forEach((readMore) => {
        readMore.addEventListener('click', (e) => {
            e.currentTarget.parentElement.parentElement.querySelectorAll('.list-collapsed, .list-expanded').forEach((item) => {
                item.classList.toggle('list-collapsed');
                item.classList.toggle('list-expanded');
            });
        });
    });
}());
